module.exports = __webpack_public_path__ + "static/media/bp5.4824657c.jpg";